import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const statusCodes = {
  Ordered: "error",
  Submitted: "error",
  Canceled: "error",
  Completed: "success",
  Delivered: "success",
};

const columns = [
  {
    field: "orderID",
    headerName: "Order ID",
    width: 100,
  },
  {
    field: "lenderFileID",
    headerName: "Lender ID",
    width: 100,
  },
  {
    field: "orderType",
    headerName: "Order Type",
    width: 150,
  },
  {
    field: "orderedByDisplay",
    headerName: "Ordered By",
    width: 200,
  },
  {
    field: "borrower",
    headerName: "Borrower",
    width: 200,
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    renderCell: ({ row }) => {
      return (
        <Chip
          label={row.status}
          variant="outlined"
          color={statusCodes[row.status] || "info"}
        />
      );
    },
  },
  {
    field: "assignee",
    headerName: "Assginee",
    width: 150,
  },
  {
    field: "address",
    headerName: "Address",
    width: 250,
    valueGetter: (value) => (value ? value.split("\n")[0] : "-"),
  },
  {
    field: "files",
    headerName: "File Count",
    width: 50,
  },
  {
    field: "paid",
    headerName: "Paid",
    width: 100,
  },
];

function CustomNoRowsOverlay() {
  return (
    <Box sx={{ mt: 4, textAlign: "center" }}>
      <Typography variant="body1">No appraisals</Typography>
    </Box>
  );
}

export default function DataTable({ files }) {
  const navigate = useNavigate();

  if (!files)
    return (
      <Box sx={{ display: "flex", textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );

  const navigateToOrder = (id) => {
    navigate(`/order/${id}`);
  };

  return (
    <div style={{ width: "100%", backgroundColor: "white" }}>
      <DataGrid
        rows={files}
        columns={columns}
        getRowId={(row) => row.orderID}
        disableColumnFilter
        disableColumnMenu
        onRowClick={(row) => navigateToOrder(row.id)}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20]}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
      />
    </div>
  );
}
